var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import Button from '@mui/material/Button';
import Dialog, { dialogClasses } from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { NotebookFeedbackCtx, notebookDefaultProperties, DatasetSelectionCtx, emptyFileSelection, emptyDatasetSelection, FileSelectionCtx, } from '../App/ApplicationContext';
const classes = {
    root: {
        margin: '0px',
        padding: '16px',
        paddingBottom: '0px',
    },
    closeButton: {
        position: 'absolute',
        right: '8px',
        top: '8px',
        color: '#9e9e9e',
    },
};
const DialogTitle = (props) => {
    const { children, onClose } = props, other = __rest(props, ["children", "onClose"]);
    return (React.createElement(MuiDialogTitle, Object.assign({ sx: classes.root }, other),
        React.createElement(Typography, { variant: 'h6', style: { minHeight: '20px' } }, children),
        onClose ? (React.createElement(IconButton, { "aria-label": 'close', sx: classes.closeButton, onClick: onClose },
            React.createElement(CloseIcon, null))) : null));
};
const DialogContent = styled(MuiDialogContent)(() => ({
    paddingRight: '16px',
    paddingLeft: '16px',
    minWidth: '500px',
    minHeight: '50px',
}));
const DialogActions = styled(MuiDialogActions)(() => ({
    margin: 0,
    padding: '8px',
}));
export const DialogWrapper = ({ title, buttonTitle, buttonCallback, buttonDisabled, size = 'sm', clearOnClose = false, children, }) => {
    const [open, setOpen] = React.useState(true);
    const { selectFiles } = useContext(FileSelectionCtx);
    const { selectDatasets } = useContext(DatasetSelectionCtx);
    const { setNotebookProperties } = useContext(NotebookFeedbackCtx);
    const handleClose = () => {
        if (clearOnClose) {
            selectFiles(emptyFileSelection);
            selectDatasets(emptyDatasetSelection);
        }
        setNotebookProperties(notebookDefaultProperties);
        setOpen(false);
    };
    return (React.createElement(Dialog, { onClose: handleClose, "aria-labelledby": 'dialog-title', open: open, maxWidth: size, fullWidth: true, sx: { [`& .${dialogClasses.paper}`]: { maxWidth: '960px' } } },
        React.createElement(DialogTitle, { id: 'dialog-title', onClose: handleClose }, title),
        React.createElement(DialogContent, null, children),
        React.createElement(DialogActions, null, buttonTitle ? (React.createElement(Button, { autoFocus: true, onClick: buttonCallback, color: 'primary', variant: 'contained', disabled: typeof buttonDisabled === 'boolean' ? buttonDisabled : true, style: {
                marginBottom: '10px',
                marginRight: '10px',
            } }, buttonTitle)) : (React.createElement("div", { style: { height: '10px' } })))));
};
